var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9914 0.646484C9.54396 0.646611 8.20906 1.42765 7.5 2.68956C6.79094 1.42765 5.45604 0.646611 4.00862 0.646484C1.79481 0.646484 0 2.69992 0 4.91373C0 10.4741 7.5 14.3534 7.5 14.3534C7.5 14.3534 15 10.4741 15 4.91373C15 2.69992 13.2052 0.646484 10.9914 0.646484Z",
    fill: "#FF5554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heartFilled.8077b183.svg";
export { ForwardRef as ReactComponent };